export default (function () {
  return {
    text: 'Learn More',
    vertical: 'Brokers'
  };
});